export default (alias: (text: string) => string = (text) => text) => [
  {
    field: 'name',
    headerName: alias('Name'),
    type: 'string',
    width: 200,
  },
  {
    field: 'header',
    headerName: alias('Header'),
    type: 'string',
    width: 200,
  },
  {
    field: 'type',
    headerName: alias('Type'),
    type: 'string',
    width: 200,
  },
  {
    field: 'isSystemWidget',
    headerName: alias('Is System Widget'),
    type: 'boolean',
    width: 200,
  },
];
